import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { useSearchFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';

interface FilterTabProps {
  searchFieldState: ReturnType<typeof useSearchFieldState>;
}

const FilterTab = ({ searchFieldState }: FilterTabProps) => {
  const { unit, setUnit } = searchFieldState;

  return (
    <div className='p-4'>
      {/* Đơn vị */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          type='text'
          name='ma_unit'
          searchEndpoint={`/${QUERY_KEYS.DON_VI_CO_SO}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={unit?.ma_unit}
          relatedFieldValue={unit?.ten_unit}
          onRowSelection={setUnit}
          className='w-100'
        />
      </div>

      {/* Trạng thái */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '0', label: 'Chưa ghi sổ' },
            { value: '3', label: 'Chờ duyệt' },
            { value: '5', label: 'Đã ghi sổ' },
            { value: '9', label: 'Hủy' }
          ]}
        />
      </div>

      {/* Lọc theo người SD */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Lọc theo người SD</Label>
        <FormField
          name='user_id0'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '1', label: 'Lọc theo người tạo' }
          ]}
        />
      </div>
    </div>
  );
};

export default FilterTab;
